/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const FREQUENCY_BANDS = [
  '1K',
  '2K',
  '3K',
  '5K',
  '10K+',
  'high_frequency_chunk',
  'common_idiom',
] as const;

export const frequencyBandSchema = z.enum(FREQUENCY_BANDS);

export type IFrequencyBand = z.infer<typeof frequencyBandSchema>;
